import { ApiResponse } from './api'
import type { ApiClient } from './api/ApiClient'
import { ServiceBase } from './api/ServiceBase'

// 托盘绑定库位请求接口
export interface BindPositionRequest {
  position_code: string
}

export class PalletV2Service extends ServiceBase {
  constructor(client: ApiClient) {
    super(client, '/v2/inbound')
  }

  // 拆托 - DELETE方法
  async dismantlePallet(palletId: number) {
    return this.delete<ApiResponse>(`/pallet/${palletId}`)
  }

  // 绑定托盘到库位
  async bindPosition(
    palletId: number,
    request: BindPositionRequest
  ): Promise<{ success: boolean; message: string }> {
    return this.put<{ success: boolean; message: string }>(
      `/pallet/${palletId}/position`,
      request
    )
  }

  // 解除绑定库位
  async unbindPosition(
    palletId: number
  ): Promise<{ success: boolean; message: string }> {
    return this.delete<{ success: boolean; message: string }>(
      `/pallet/${palletId}/position`
    )
  }
}

export default PalletV2Service
